












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/piscine/edit/EditContent.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'ReadContent',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadContent extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
